import type {
  ApiAvailableIp,
  ApiAvailableIpsResponse,
  ApiCreateIpPoolResponse,
  ApiIpPool,
  ApiIpPoolsResponse,
  AvailableIp,
  AvailableIpsData,
  CreateIpPoolResult,
  IpPool,
  IpPoolsData,
} from '../types';

export function mapIpPool(pool: ApiIpPool): IpPool {
  return {
    name: pool.name,
    ips: pool.ips ?? [],
    domainsCount: pool.domains_count,
  };
}

export function mapIpPoolsResponse(response: ApiIpPoolsResponse): IpPoolsData {
  return {
    available: response.available,
    pools: (response.pools ?? []).map(mapIpPool),
  };
}

export function mapAvailableIp(ip: ApiAvailableIp): AvailableIp {
  return {
    ip: ip.ip,
    pools: ip.pools ?? [],
    warmup: ip.warmup ?? false,
  };
}

export function mapAvailableIpsResponse(response: ApiAvailableIpsResponse): AvailableIpsData {
  return {
    available: response.available,
    ips: (response.ips ?? []).map(mapAvailableIp),
  };
}

export function mapCreateIpPoolResponse(response: ApiCreateIpPoolResponse): CreateIpPoolResult {
  return {
    pool: mapIpPool(response.pool),
    failedIps: response.failed_ips ?? [],
  };
}
